const cardItems = [
  {
    tag: '深度',
    title: '明星人设崩塌背后：娱乐圈公关团队的博弈真相',
    desc: '从声明到律师函，从沉默到反击，深度解析明星危机公关的标准操作流程与真实博弈。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20with%20warm%20crimson%20and%20deep%20amber%20tones%2C%20chess%20pieces%20silhouette%20in%20dramatic%20lighting%2C%20representing%20strategy%20and%20public%20relations%2C%20modern%20magazine%20layout%20aesthetic%2C%20clean%20minimal%20composition%20with%20atmospheric%20depth&width=600&height=400&seq=cards-01&orientation=landscape',
    date: '2026-07-28',
    author: '深度编辑组',
  },
  {
    tag: '盘点',
    title: '2026年上半年十大最令人意外的娱乐圈反转事件',
    desc: '从全民声讨到真相大白，这些反转剧情比电视剧还精彩，每一件都让人始料未及。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20toned%20dramatic%20illustration%20with%20twist%20and%20turn%20maze%20path%20visual%20metaphor%2C%20crimson%20and%20golden%20gradient%20background%2C%20modern%20editorial%20design%20with%20geometric%20elements%2C%20clean%20professional%20aesthetic%2C%20atmospheric%20composition&width=600&height=400&seq=cards-02&orientation=landscape',
    date: '2026-07-27',
    author: '盘点小组',
  },
  {
    tag: '独家',
    title: '综艺节目制作人匿名爆料：那些你不知道的录制潜规则',
    desc: '多位匿名综艺制作人首次对外揭露行业内幕，从选角内定到剪辑操控，还原真实录制生态。',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20abstract%20illustration%20with%20warm%20amber%20spotlight%20and%20shadow%20play%2C%20film%20set%20atmosphere%20with%20dramatic%20lighting%2C%20crimson%20curtain%20visual%20elements%2C%20modern%20editorial%20aesthetic%2C%20mysterious%20ambient%20composition&width=600&height=400&seq=cards-03&orientation=landscape',
    date: '2026-07-26',
    author: '独家报道组',
  },
  {
    tag: '分析',
    title: '网红经济下半场：从流量狂欢到精细化运营的转型之路',
    desc: '当流量红利消退，头部网红如何转型求变？深度分析网红行业最新趋势与未来发展。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20digital%20economy%20abstract%20illustration%20with%20warm%20crimson%20and%20golden%20data%20visualization%20elements%2C%20growth%20chart%20and%20network%20connections%20in%20minimalist%20style%2C%20clean%20professional%20business%20aesthetic%2C%20atmospheric%20warm%20tones&width=600&height=400&seq=cards-04&orientation=landscape',
    date: '2026-07-25',
    author: '行业分析组',
  },
  {
    tag: '趣闻',
    title: '那些年被我们吃过的"假瓜"：经典谣言大盘点与真相还原',
    desc: '回顾近年最经典的娱乐圈谣言事件，看看当年那些让全网沸腾的"大瓜"最终如何反转。',
    img: 'https://readdy.ai/api/search-image?query=Whimsical%20abstract%20illustration%20with%20warm%20golden%20amber%20and%20soft%20crimson%20tones%2C%20floating%20question%20marks%20and%20news%20fragments%20in%20playful%20composition%2C%20modern%20editorial%20layout%20style%2C%20clean%20minimal%20design%20with%20atmospheric%20depth&width=600&height=400&seq=cards-05&orientation=landscape',
    date: '2026-07-24',
    author: '趣闻编辑组',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选速递
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            编辑精选的深度吃瓜好文，带你看到热点之外的故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className={`group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/70 transition-all cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div
                className={`relative overflow-hidden ${
                  idx === 0 ? 'aspect-[2/1] sm:aspect-[16/7]' : 'aspect-[16/10]'
                }`}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-primary-500/85 text-background-50 text-xs font-semibold rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.date}</span>
                  <span>{item.author}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}